module.exports = __webpack_public_path__ + "img/flex.2fa544bb.svg";